// Partner Products Dashboard - Contact Search Autocomplete
// This implements a lightweight autocomplete for contact selection without loading all contacts

document.addEventListener('turbo:load', initContactSearch);
document.addEventListener('DOMContentLoaded', initContactSearch);

// Re-initialize when modals are shown
document.addEventListener('shown.bs.modal', function (event) {
  const modal = event.target;
  if (modal.id && (modal.id.startsWith('assignProductModal') || modal.id === 'enrollContactModal')) {
    initContactSearchInModal(modal);
  }
});

function initContactSearchInModal(modal) {
  const selectElements = modal.querySelectorAll('.contact-search-select');
  selectElements.forEach(selectElement => {
    // Reset initialization flag to force re-init
    delete selectElement.dataset.initialized;
    initSingleContactSearch(selectElement);
  });
}

function initContactSearch() {
  const selectElements = document.querySelectorAll('.contact-search-select');
  selectElements.forEach(selectElement => {
    initSingleContactSearch(selectElement);
  });
}

function initSingleContactSearch(selectElement) {
    if (selectElement.dataset.initialized) return;
    selectElement.dataset.initialized = 'true';

    const searchUrl = selectElement.dataset.searchUrl;
    if (!searchUrl) return;

    // Create custom search UI
    const wrapper = document.createElement('div');
    wrapper.className = 'contact-search-wrapper';
    wrapper.style.position = 'relative';

    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'form-control contact-search-input';
    searchInput.placeholder = 'Type to search contacts by name or email...';
    searchInput.autocomplete = 'off';

    const resultsDropdown = document.createElement('div');
    resultsDropdown.className = 'contact-search-results';
    resultsDropdown.style.cssText = `
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      max-height: 300px;
      overflow-y: auto;
      background: white;
      border: 1px solid #ddd;
      border-top: none;
      border-radius: 0 0 4px 4px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      z-index: 1000;
      display: none;
    `;

    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'contact-search-loading';
    loadingIndicator.style.cssText = `
      padding: 10px;
      text-align: center;
      color: #666;
      display: none;
    `;
    loadingIndicator.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Searching...';

    // Hide original select
    selectElement.style.display = 'none';

    // Insert new elements
    selectElement.parentNode.insertBefore(wrapper, selectElement);
    wrapper.appendChild(searchInput);
    wrapper.appendChild(resultsDropdown);
    wrapper.appendChild(loadingIndicator);
    wrapper.appendChild(selectElement);

    let searchTimeout;
    let selectedContactId = null;

    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();

      clearTimeout(searchTimeout);

      if (query.length < 2) {
        resultsDropdown.style.display = 'none';
        return;
      }

      loadingIndicator.style.display = 'block';
      resultsDropdown.style.display = 'none';

      searchTimeout = setTimeout(() => {
        fetchContacts(query);
      }, 300);
    });

    searchInput.addEventListener('focus', () => {
      if (searchInput.value.trim().length >= 2) {
        resultsDropdown.style.display = 'block';
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) {
        resultsDropdown.style.display = 'none';
      }
    });

    function fetchContacts(query) {
      fetch(`${searchUrl}?q=${encodeURIComponent(query)}`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        loadingIndicator.style.display = 'none';
        displayResults(data.results);
      })
      .catch(error => {
        console.error('Error fetching contacts:', error);
        loadingIndicator.style.display = 'none';
        resultsDropdown.innerHTML = '<div style="padding: 10px; color: #dc3545;">Error loading contacts</div>';
        resultsDropdown.style.display = 'block';
      });
    }

    function displayResults(results) {
      resultsDropdown.innerHTML = '';

      if (results.length === 0) {
        resultsDropdown.innerHTML = '<div style="padding: 10px; color: #666;">No contacts found</div>';
        resultsDropdown.style.display = 'block';
        return;
      }

      results.forEach(contact => {
        const item = document.createElement('div');
        item.className = 'contact-search-result-item';
        item.style.cssText = `
          padding: 10px 15px;
          cursor: pointer;
          border-bottom: 1px solid #f0f0f0;
        `;
        item.innerHTML = `
          <div style="font-weight: 500;">${escapeHtml(contact.name || contact.email)}</div>
          ${contact.name ? `<div style="font-size: 0.9em; color: #666;">${escapeHtml(contact.email)}</div>` : ''}
        `;

        item.addEventListener('mouseenter', () => {
          item.style.backgroundColor = '#f8f9fa';
        });

        item.addEventListener('mouseleave', () => {
          item.style.backgroundColor = 'white';
        });

        item.addEventListener('click', () => {
          selectContact(contact);
        });

        resultsDropdown.appendChild(item);
      });

      resultsDropdown.style.display = 'block';
    }

    function selectContact(contact) {
      selectedContactId = contact.id;
      searchInput.value = contact.text;

      // Update hidden select
      selectElement.innerHTML = '';
      const option = document.createElement('option');
      option.value = contact.id;
      option.text = contact.text;
      option.selected = true;
      selectElement.appendChild(option);

      resultsDropdown.style.display = 'none';

      // Mark input as valid
      searchInput.classList.remove('is-invalid');
      searchInput.classList.add('is-valid');
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Form validation
    const form = selectElement.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!selectElement.value) {
          e.preventDefault();
          searchInput.classList.add('is-invalid');
          searchInput.focus();
          return false;
        }
      });
    }
}
